module.exports = __webpack_public_path__ + "26411f027a3a1adf2e93df57b55807d3.png";